const DEFAULT_APP_NAME = 'Central de Cobrança'
const DEFAULT_CLIENT_NAME = 'Cliente'
const DEFAULT_API_URL = '/api/v1'

const fromEnv = (value: string | undefined, fallback: string) => value?.trim() || fallback
const optionalEnv = (value: string | undefined) => value?.trim() || null

/** Configuração pública do web (variáveis VITE_*), sempre com valor definido. */
export const appConfig = Object.freeze({
  appName: fromEnv(import.meta.env.VITE_APP_NAME, DEFAULT_APP_NAME),
  clientName: fromEnv(import.meta.env.VITE_CLIENT_NAME, DEFAULT_CLIENT_NAME),
  apiUrl: fromEnv(import.meta.env.VITE_API_URL, DEFAULT_API_URL).replace(/\/+$/, ''),
  /** Só esconde a seção de push; quem decide é a API (503 sem VAPID). */
  pushEnabled: import.meta.env.VITE_PUSH_ENABLED?.trim() !== 'false',
  /** Sprint 15: commit e data deste build (null em desenvolvimento). */
  gitSha: optionalEnv(import.meta.env.VITE_GIT_SHA),
  buildTime: optionalEnv(import.meta.env.VITE_BUILD_TIME),
})
